import React from 'react';
import { tUi } from '../../../../../../../../utils/dq_lc';
import {
  SlideDescription,
  SlideTitle,
} from '../../../../../styles/LearnTab/slideBase.styles';
import { SlideTitleHeader } from '../common/SlideTitleHeader.comp';
import { renderTextWithId } from '../common/EditableSlideField.comp';

export const RecapSlide = ({
  slide,
  highlightWord,
  slideEdits = {},
  showEnglishContent = false,
  uiLocale = 'en-US',
}) => {
  const origin = slide?._pbdq_origin || slide || {};
  const r = slide?.RecapData || origin;
  const title = slide?.SlideTitle || r.headline || r.title || tUi('slide.recap.titleDefault', uiLocale);

  const textRendererOptions = { slideEdits, showEnglishContent, highlightWord };

  if (!r || (!r.big_idea_question && !r.answer && !r.support_points && !slide?.SlideContent)) {
    return (
      <SlideDescription>
        <SlideTitleHeader
          slide={slide}
          slideEdits={slideEdits}
          showEnglishContent={showEnglishContent}
          highlightWord={highlightWord}
        />
        {renderTextWithId('content_0', slide?.SlideContent, 'div', {}, textRendererOptions)}
      </SlideDescription>
    );
  }

  const isT7 = r.is_t7 || origin.tier === 'T7' || slide?.tier === 'T7' || r.short_answer;

  return (
    <SlideDescription>
      {title && (
        <SlideTitle>
          {highlightWord ? highlightWord('title', title) : title}
        </SlideTitle>
      )}

      {r.big_idea_question && (
        <div style={{ fontSize: '1.05rem', color: '#111827', margin: '4px 0 16px', lineHeight: 1.5, textAlign: 'left', width: '100%' }}>
          <strong>{tUi('slide.recap.ourBigQuestion', uiLocale)}</strong> {renderTextWithId('recap_question', r.big_idea_question, 'span', {}, textRendererOptions)}
        </div>
      )}

      {isT7 ? (
        <>
          {r.short_answer && (
            <div style={{ fontSize: '1rem', color: '#374151', margin: '12px 0', lineHeight: 1.6, textAlign: 'left', width: '100%' }}>
              <strong style={{ color: '#111827' }}>{r.short_answer_title || tUi('slide.recap.shortAnswer', uiLocale)}</strong>{' '}
              {renderTextWithId('recap_short', r.short_answer, 'span', {}, textRendererOptions)}
            </div>
          )}
          {r.long_answer_title && (
            <div style={{ fontSize: '1.05rem', fontWeight: 700, color: '#111827', marginTop: 16, marginBottom: 8, textAlign: 'left', width: '100%' }}>
              {r.long_answer_title}
            </div>
          )}
          <ul className="recap-list" style={{ textAlign: 'left', width: '100%' }}>
            {(r.support_points || []).map((p, idx) => (
              <li key={idx} style={{ textAlign: 'left' }}>
                {typeof p === 'object' && p !== null ? (
                  <>
                    <strong>{p.heading}</strong>
                    {p.heading && p.explanation ? ' — ' : ''}
                    {renderTextWithId(`recap_pt_${idx}`, p.explanation || '', 'span', {}, textRendererOptions)}
                  </>
                ) : (
                  renderTextWithId(`recap_pt_${idx}`, String(p), 'span', {}, textRendererOptions)
                )}
              </li>
            ))}
          </ul>
          {r.bulb_insight && (
            <div className="content-so-what" style={{ marginTop: 20, textAlign: 'left', width: '100%' }}>
              💡 {renderTextWithId('recap_bulb', r.bulb_insight.replace(/^💡\s*/, ''), 'span', {}, textRendererOptions)}
            </div>
          )}
        </>
      ) : (
        <>
          <div style={{ fontSize: '1rem', color: '#475569', margin: '12px 0 8px' }}>
            {tUi('slide.recap.howWhatYouLearned', uiLocale)}
          </div>
          <ul className="recap-list" style={{ paddingLeft: 24, marginBottom: 16 }}>
            {(r.support_points || []).map((p, idx) => (
              <li key={idx} style={{ marginBottom: 8 }}>
                {renderTextWithId(`recap_pt_${idx}`, typeof p === 'string' ? p : String(p?.explanation || p), 'span', {}, textRendererOptions)}
              </li>
            ))}
          </ul>
          {r.answer && (
            <div className="content-so-what" style={{ marginTop: 20 }}>
              💡 {renderTextWithId('recap_answer', r.answer.replace(/^💡\s*/, ''), 'span', {}, textRendererOptions)}
            </div>
          )}
        </>
      )}
    </SlideDescription>
  );
};

export default RecapSlide;
